/* Pearl and Post Atelier: Shopify XR (AR/3D, 32 kB) alleen laden op een pagina met een 3D-model.
   Agent snelheid, 19 okt 2026 (SNELHEID.md, voorstel V1). Broadcast theme.js laadt shopify-xr bij DOMContentLoaded op
   elke pagina. Dit bestand staat direct na theme.js (beide defer), draait dus na theme.js en voor DOMContentLoaded,
   en zet window.ProductModel uit als er geen 3D-model is. Terugdraaien: de script-regel in layout/theme.liquid weghalen. */
(function () {
  try {
    if (document.querySelector('model-viewer')) return;
    var heeftModel = false;
    document.querySelectorAll('script[id^="ModelJSON-"]').forEach(function (s) {
      try { if (JSON.parse(s.textContent || '[]').length) heeftModel = true; } catch (e) { heeftModel = true; }
    });
    if (!heeftModel) window.ProductModel = undefined;
  } catch (e) {}
})();
